package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
internal data class OverpassResult(
    val elements: List<OverpassElement>,
)
